










































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

import moment from "moment";

import { getBillInfoMessageByAttr } from "@/libs/bill";

@Component
export default class extends Mixins(MyForm) {
  @Prop({ default: 0 }) isOld!: number;

  @Prop({ default: 0 }) playerStatus!: number;

  @Prop() status!: any[];

  @Prop() types!: any[];

  @Prop() perception!: any;

  // 1： 加入组局，2：已响应，3：去不了 4, 应邀参加，5：下单，6：离开，7：加入其他组局， 8：解散
  opStatus: any = {
    1: "加入组局",
    2: "已响应",
    3: "去不了",
    4: "应邀参加",
    5: "下单",
    6: "离开组局",
    7: "加入其他组局",
    8: "解散解散"
  };

  playerStatusList: any = [
    {
      id: 1,
      name: "未响应"
    },
    {
      id: 2,
      name: "应邀"
    },
    { id: 3, name: "去不了" }
  ];

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("groupPerception/detail", {
      id: this.editId,
      is_old: this.isOld
    });

    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }

  filterLog(player: any) {
    let ret = [];
    if (this.formData.logs && this.formData.logs.length) {
      ret = this.formData.logs.filter(
        (log: any) => log.user_id == player.user_id
      );
    }

    return ret;
  }

  get typeText() {
    const el = this.types.find(el => el.id == this.formData.perception.type);
    if (el) {
      return el.name;
    }
    return "";
  }

  getPlayerStatusListText(status: number) {
    switch (status) {
      case 0:
        return "";
      case 1:
        return "未应答";
      case 2:
        return "应邀";
      case 3:
        return "去不了";
    }
  }

  getStatusText(status: number): string {
    if (status == 0) {
      status = -1;
    }

    const el = this.status.find(el => el.id == status);
    if (el) {
      return el.name;
    }
    return "";
  }

  get bill() {
    if (this.formData.bill) {
      return this.formData.bill;
    }
    return {};
  }

  // 下单人
  isBookingUser(userId: number) {
    return this.bill.user_id == userId;
  }

  billAttr(attr: string) {
    const { bill } = this;
    return getBillInfoMessageByAttr(bill, attr);
  }

  get statusText() {
    const { status } = this.formData.perception;
    return this.getStatusText(status);
  }

  get playerStatusListBy() {
    if (this.playerStatus == 0) {
      return this.playerStatusList;
    }

    return this.playerStatusList.filter(
      (el: any) => el.id == this.playerStatus
    );
  }

  filterPlayers(status: any) {
    const players = [];
    if (this.formData && this.formData.players) {
      return this.formData.players.filter((el: any) => el.status == status);
    }
  }

  getDate(log: any) {
    return moment(log.created_time).format("MM-DD HH:mm:ss");
  }

  getOpStatusText(opStatus: number) {
    return this.opStatus[opStatus] || "";
  }
}
